import React from "react";

import { classNames } from "../../../helpers/classNames";
import useFetch from "../../../hooks/useFetch";
import { dashboardCount } from "../../../services/dashboardService";
import { formatNumber } from "../../../helpers";

const DashboardCount = () => {
  const { data, error, isLoading, isFetching, refetch, updateData } = useFetch({
    dependencies: ["dashboard-count"],
    fetchFunction: async () => {
      return dashboardCount();
    },
  });

  const countData = [
    {
      title: "Total Admin",
      count: data?.data?.adminCount || 0,
      bgClass: "bg-[#ecd4d5]",
    },
    {
      title: "Total Users",
      count: data?.data?.userCount || 0,
      bgClass: "bg-[#C9CDCE]",
    },

    {
      title: "Total Post",
      count: data?.data?.postCount || 0,
      bgClass: "bg-[#ecd4d5]",
    },
    {
      title: "Total Task",
      count: data?.data?.taskCount || 0,
      bgClass: "bg-[#C9CDCE]",
    },
    {
      title: "Total Category",
      count: data?.data?.categoryCount || 0,
      bgClass: "bg-[#D3C8C8]",
    },
  ];
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-4">
      {countData?.map((item, i) => (
        <div
          key={i?.toString()}
          className={classNames(
            "w-full aspect-[3/2] rounded-lg h-full flex flex-col items-center justify-center py-4 px-4 space-y-4",
            item?.bgClass
          )}
          style={item?.bg && { background: item?.bg }}
        >
          <div className="text-5xl font-bold text-center font-CanelaDeck">
            {item?.count}
          </div>
          <div className="text-2xl font-bold text-center font-CanelaDeck">
            {item?.title}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardCount;
